const STORAGE_KEY = 'ninenights-recently-read'
const MAX_RECENT_STORIES = 8

export function getRecentlyReadStoryIds(): string[] {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    return Array.isArray(value) ? value.filter((id): id is string => typeof id === 'string') : []
  } catch {
    return []
  }
}

export function rememberRecentlyReadStory(publicationId: string): void {
  const ids = getRecentlyReadStoryIds().filter((id) => id !== publicationId)
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify([publicationId, ...ids].slice(0, MAX_RECENT_STORIES))
  )
}
